const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/admin/email/send-log.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { EmailLogFilterParamSchema } from '@apps/main/features/admin/pages/email/send-log-schema';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_main/admin/email/send-log')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: EmailLogFilterParamSchema
});